import React from 'react';

import '@assets/charm.css';

import { CardsRoutesProvider } from '@apps/card/Card.routes';
import { CardCategoryProvider } from '@apps/card/routes/Dashboard/components/CardCategoryProvider';
import { Redirect, Route, RoutesProvider, Switch } from '@shared/core';
import { Gallery } from './routes/Gallery';
import ImagineYourCard from '@apps/card/imagineYourCard';
import { AICardRouter } from '@apps/card/imagineYourCard/router';
import { PublicEnvelopes } from './routes/Envelopes';
import { FullScreenLogin } from './components/login/FullScreenLogin';
import { PublicCardShopTelemetryProvider } from './PublicShop.telemetry';

/**
 * TODO:
 * - Consolidate required providers into one wrapper component
 */
export const PublicShop = () => {
  return (
    <>
      <PublicCardShopTelemetryProvider>
        <AICardRouter>
          <RoutesProvider>
            <CardsRoutesProvider>
              <CardCategoryProvider>
                <Switch>
                  <Route
                    path="/cards/:occasion/:category/imagine"
                    render={() => <ImagineYourCard />}
                  />
                  <Route
                    path="/cards/envelopes"
                    render={() => <PublicEnvelopes />}
                  />
                  <Route
                    path="/cards"
                    render={() => <Gallery eventId={''} />}
                  />
                  <Redirect to="/cards" />
                </Switch>
                <FullScreenLogin />
              </CardCategoryProvider>
            </CardsRoutesProvider>
          </RoutesProvider>
        </AICardRouter>
      </PublicCardShopTelemetryProvider>
    </>
  );
};
